var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$apollo.loading)?[_c('loading')]:[(_vm.title)?_c('h1',{staticClass:"title is-size-4 is-size-5-mobile has-text-weight-extra-bold"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('album-list',{attrs:{"albums":_vm.albums}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }